<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->
    <v-btn v-if="!yesForm" color="success" @click.native="addNew" >
      Add New
    </v-btn>

    <!-- <insertForm ref="sendFormData" v-if="yesForm" v-on:emitForm="close"></insertForm> -->

      <insertForm v-if="yesForm" :dateValue="dateValue" :formSchema="formSchema"  v-on:emitForm="close" v-on:backFormschema="setFormSchema"></insertForm>
      
      <!-- <insertForm v-if="yesForm" :dateValue="dateValue" :formSchema="formSchema"  v-on:emitForm="close"></insertForm> -->

    <v-card-title v-if="!yesForm">
      <h2>Code Wise Fund Release</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <div v-if="!yesForm">
    <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
        <td class="text-xs-center">{{ props.item.financial_year }}</td>
        <td class="text-xs-center">{{ changeFormateDMY(props.item.received_date) }}</td>

        <td class="text-xs-left">
          <v-btn v-if="props.item.document_01" icon class="mx-0" @click="downloadFile(props.item.document_01)">
            <v-icon color="purple">image</v-icon>
          </v-btn>
          <v-btn v-else icon disabled class="mx-0" title="Empty File">
            <v-icon color="purple">image</v-icon>
          </v-btn>
        </td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="viewDetails(props.item.id)" title="Detail">
              <v-icon color="teal">view_module</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteItem(props.index, props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>          
        </td>
      </template>
    </v-data-table>
  </div>
  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import insertForm from "./insertForm";
import Axios from "axios";
import ServerPath from "../../../server-path/server-path";

export default {
  components: {
    insertForm
  },

  data: () => ({
    valid: true,

    yesForm:false,

   dateValue:{
      id:0,
      financial_year:'',
      received_date:'',
      document_01: "",
    },

    formSchema: [
        {
          id: 0,
          eco_code_id: "",
          eco_account_code:"",
          eco_account_name: "", 
                 
          budget_gob_amount:0,    
          budget_ida_amount:0,
          budget_total_amount:0,
                  
          received_amount:0,
          pay_gob_amount:0,
          pay_ida_amount:0,
          total_pay_amount:0,       
        },
      ], 



    /*------------- Datatable ---------------*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      {
        text: "SL",
        value: ""
      },
      {
        text: "Financial Year",
        align: "center",
        sortable: true,
        value: "financial_year"
      },
      {
        text: "Received Date",
        align: "center",
        sortable: true,
        value: "received_date"
      },
       {
        text: "Uploaded File",
        align: "left",
        sortable: true,
        value: "document_01"
      },
      {
        text: "Action",
        align: "center",
        sortable: false,
        value: ""
      },      
    ],
    /*------------- /Datatable ---------------*/

    delete_id: "",
    row_index: "",
    dialog2: false,
    
    SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },    
  }),

  /*------------Datatable------------*/
  created() {
    
  },

  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    }
  },
  /*------------/Datatable------------*/

  methods: {
    /**
     * add pdf view services...
     */
    viewDetails (id) {
      let route = ServerPath.serverPath+'/budget-wise-details/'+id;
      window.open(route, '_blank');
    
    },

     downloadFile(fileName) {
      
      let url = ServerPath.serverPath+fileName;
       window.open(url);      
    },

    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();
        
        if(search)
        {
          search = this.changeFormateYMD(search);
        }

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "budget-wise-fund-release-list")
          .then(res => {
            let items = res.data;

            const total = res.totalRecords;
            /*if(total == 0)
            {
              this.yesForm = true;
            }*/

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    downloadFile(fileName) {
      let url = ServerPath.serverPath+fileName;
      window.open(url);      
    },
    
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    editItem(index, item) {
            
        commonService.getAllData("get-financial-year-data/"+item.financial_year+"/"+item.id).then(res => {

          if(res.proBudget_detail)
          {  
                
            this.yesForm = true;
            var formData = '';
            formData = res.masterData            
            formData.received_date = this.changeFormateDMY(
              res.masterData.received_date
              ); 

            this.dateValue = formData;
            this.formSchema = res.proBudget_detail;                        
          }

        });    
    },

    addNew(){
      //this.dateValue.id = 0;            
      this.yesForm = true;
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "budget-wise-fund-release").then(res => {
        if (res.status == 1) {
          this.desserts.splice(row_index, 1);          
          this.SnackbarVal.color = "success"
        }
        else
        {
          this.SnackbarVal.color = "error"; 
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
        
        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    setFormSchema(data){
      console.log('emit data = ', data);
      this.formSchema = data.formSchema
    },

    close(res) {
      if(res.status == 'back')
      {
        this.yesForm = false;
        location.reload();
      }
      else
      {
        let $this = this;
        if (res.status == 1) {
          this.yesForm = false;
          this.SnackbarVal.color = "success"
          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;

          setTimeout(() => {
            location.reload();
          }, 5000); 
        }        
      }


    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/project_info/budgetWiseFundRelease/dataTable.vue